var storefrontApp = angular.module("storefrontApp");
storefrontApp.service('contestService', ['$http', '$httpParamSerializer', function ($http, $httpParamSerializer) {
    return {
        getContestWinners: function () {
            return $http.get('storefrontapi/contests/getcontestwinners');
        },
        getActiveUpcomingContests: function () {
            return $http.get('storefrontapi/contests/getactiveandnewcontests');
        },
        checkActiveContest: function (contestId) {
            return $http.get('storefrontapi/contests/checkactivecontest/' + contestId);
        },
        insertContestEntry: function (entry, imageFile) {
            var formData = new FormData();
            formData.append("entry", angular.toJson(entry));
            formData.append("imageFile", imageFile, imageFile.name);
            return $http.post(
                "storefrontapi/contests/insertentry",
                formData,
                {
                    headers: { "Content-Type": undefined },
                }
            );
        },
        getContestsBySite: function () {
            return $http.get('storefrontapi/contests/getcontestbysite');
        },
        getContestEntries: function (contestId) {
            return $http.get('storefrontapi/contests/getcontestentries/' + contestId);
        },
        getContestAppsettings: function () {
            return $http.get('storefrontapi/contests/getcontestappsettings');
        },
        getProductInfo: function (productIds) {
            return $http.get('storefrontapi/products?' + $httpParamSerializer({ productIds: productIds }));
        }
    }
}]);
